import request from '@/utils/request'


// 查询积分/金币兑换码管理列表
export function listDuihuan(query) {
  return request({
    url: '/zb/duihuan/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询积分/金币兑换码管理分页
export function pageDuihuan(query) {
  return request({
    url: '/zb/duihuan/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询积分/金币兑换码管理详细
export function getDuihuan(data) {
  return request({
    url: '/zb/duihuan/detail',
    method: 'get',
    params: data
  })
}

// 新增积分/金币兑换码管理
export function addDuihuan(data) {
  return request({
    url: '/zb/duihuan/add',
    method: 'post',
    data: data
  })
}

// 修改积分/金币兑换码管理
export function updateDuihuan(data) {
  return request({
    url: '/zb/duihuan/edit',
    method: 'post',
    data: data
  })
}

// 删除积分/金币兑换码管理
export function delDuihuan(data) {
  return request({
    url: '/zb/duihuan/delete',
    method: 'post',
    data: data
  })
}
